import React from 'react';
import {CloseButton, Flex} from '@chakra-ui/react';
import {
  BusinessAudience,
  BusinessAudienceLabels,
} from '../../../shared/account';
import {keys} from '../../../shared/util';
import {FilterSelect} from './FilterSelect';

const audienceOptions = keys(BusinessAudienceLabels).map((value) => ({
  value,
  label: BusinessAudienceLabels[value],
}));
const filterSelectionOptions = {
  include: {label: 'include any of', value: 'include any of'},
};

export const AudienceFilterControl = ({
  audience,
  setAudience,
  onRemove,
}: {
  audience: BusinessAudience[];
  setAudience: (audience: BusinessAudience[]) => void;
  onRemove?: () => void;
}) => {
  const selectedAudienceOptions = audience.map((value) => ({
    value,
    label: BusinessAudienceLabels[value],
  }));

  return (
    <Flex gap="2" flex={2} alignItems="center">
      <FilterSelect
        variant="operator"
        options={Object.values(filterSelectionOptions)}
        value={filterSelectionOptions.include}
      />
      <FilterSelect
        options={audienceOptions}
        isMulti
        onChange={(values) =>
          setAudience(values.map((v) => v.value) as BusinessAudience[])
        }
        value={selectedAudienceOptions}
      />
      <CloseButton onClick={onRemove} />
    </Flex>
  );
};
